import { Component, signal } from '@angular/core';

import { BlockTextComponent, EditorInputComponent, WysiswgBlockData } from '@camelot/wysiswyg';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [BlockTextComponent, EditorInputComponent, TestIdDirective],
    template: `
    <cam-cms-editor-input camTestId="cam-cms-editor-input" (changed)="this.onChanged($event)" />
    <div camTestId="wy-changed">{{ this.lastChange() }}</div>
    <cam-cms-editor-blocks camTestId="cam-cms-editor-blocks" [blocks]="this.blocks" />
  `
})
export class WysiswygCase {
  public blocks: WysiswgBlockData[] = [{ data: { text: 'Hello block' }, type: 'paragraph' }];
  public lastChange = signal('');

  public onChanged(event: { blocks: WysiswgBlockData[] }): void {
    this.lastChange.set(JSON.stringify(event.blocks));
  }
}
